import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Images from "../../assests/index"

const Header = () => {
    return (
        <AppBar position="static" sx={{ backgroundColor: "#f5f5f5", color: "black",boxShadow : 'rgba(0, 0, 0, 0.24) 0px 3px 8px'}}>
            <Toolbar sx={{display:'flex',alignItems:'baseline'}}>
                {/* Left side: Logo */}
                <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', background: 'none' }}>
                    <img
                        src={Images.logo}
                        alt="Logo"
                        style={{ height: "50px", objectFit: "contain" }}
                    />
                </Box>




                {/* Right side: Notification icon */}
                <IconButton edge="end" color="inherit" aria-label="notifications">
                    <NotificationsIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
